import type { TvChannel } from '@setplex/tria-api'
import type { TvChannelPayment } from '../interfaces'

import { getPriceSettingsExternalPaymentData } from '~/shared/price-settings/helpers'
import { getPaymentTvChannelMediaType } from './media-type'

interface FormatChannelExternalPaymentParams {
  channel: TvChannelPayment
  shouldRefresh?: boolean
}
export const formatChannelExternalPayment = ({
  channel,
  shouldRefresh = false,
}: FormatChannelExternalPaymentParams) => {
  const { id, priceSettings, externalId } = channel
  return {
    id,
    mediaType: priceSettings
      ? getPaymentTvChannelMediaType(priceSettings)
      : null,
    shouldRefresh,
    ...getPriceSettingsExternalPaymentData(priceSettings, externalId),
  }
}

export const formatTvChannelPayment = (
  channel: TvChannel,
  query: URLSearchParams
): TvChannelPayment => {
  const categoryId = query.get('categoryId')
  const {
    priceSettings,
    free,
    purchaseInfo,
    logoUrl,
    name,
    id,
    channelNumber,
  } = channel

  return {
    ...channel,
    priceSettings: priceSettings ?? null,
    free: Boolean(free),
    purchaseInfo: purchaseInfo ?? null,
    logoUrl: logoUrl ?? '',
    name: String(name),
    id: Number(id),
    channelNumber: channelNumber ?? 0,
    categoryId: categoryId == null ? 0 : Number(categoryId),
    mediaType: priceSettings
      ? getPaymentTvChannelMediaType(priceSettings)
      : null,
  }
}
